import moment from 'moment';
import * as actions from 'redux/store/actions';
import difference from '../../../../../utils/difference';


class SprintEditorPopup {
  constructor($ngRedux, $scope, $translate, durationService) {
    'ngInject';
    this.$translate = $translate;
    this.formatter = durationService.getFormatter({ mode: 'hm' });

    const mapStateToThis = state => ({
      sprint: state.configuration.sprint.fieldset.sprintValue,
      recommendedCapacity: state.configuration.sprint.fieldset.recommendedCapacity,
      startDateMin: state.configuration.sprint.fieldset.startDateMin,
      startDateMax: state.configuration.sprint.fieldset.startDateMax,
      hasNext: state.configuration.sprint.fieldset.hasNext,
      hasPrev: state.configuration.sprint.fieldset.hasPrev,
      endDateMin: state.configuration.sprint.fieldset.endDateMin,
      currentTab: state.configuration.sprint.fieldset.currentTab,
      weekOptions: state.configuration.sprint.fieldset.weekOptions,
      selectedWeek: state.configuration.sprint.fieldset.selectedWeek,
      weekDetails: state.configuration.sprint.fieldset.weekDetails,
      userWeekDays: state.configuration.sprint.fieldset.userWeekDays,
      loading: state.services.api.configuration.sprint.valueFetching ||
        state.services.api.configuration.sprint.upserting ||
        state.services.api.configuration.sprint.completing ||
        state.services.api.configuration.sprint.activating,
      origValues: state.configuration.sprint.fieldset.origValues,
      costOfEstimationModel: state.configuration.sprint.fieldset.costOfEstimationModel,
    });
    const mapDispatchToThis = ({
      save: actions.configuration.sprint.editor.save.begin,
      complete: actions.configuration.sprint.editor.complete.begin,
      activate: actions.configuration.sprint.editor.activate.begin,
      load: actions.configuration.sprint.editor.load.begin,
      create: actions.configuration.sprint.creator.open.begin,
      close: actions.configuration.sprint.editor.close,
      setTab: actions.configuration.sprint.fieldset.setTab,
      setWeek: actions.configuration.sprint.fieldset.setWeek,
      setUserDay: actions.configuration.sprint.fieldset.setUserDay.begin,
      setName: actions.configuration.sprint.fieldset.setName,
      setStartDate: actions.configuration.sprint.fieldset.setStartDate,
      setEndDate: actions.configuration.sprint.fieldset.setEndDate,
      setCapacity: actions.configuration.sprint.fieldset.setCapacity,
      setHourCapacity: actions.configuration.sprint.fieldset.setHourCapacity,
      undo: actions.configuration.sprint.fieldset.resetChanges,
      remove: actions.configuration.sprint.fieldset.remove,
      setCostOfEstimation: actions.configuration.sprint.fieldset.setCostOfEstimation.begin,
      inheritCostChange: actions.configuration.sprint.fieldset.setCostInherit.begin,
      setWorkingDuration: actions.configuration.sprint.fieldset.setWorkingDuration.begin,
    });
    const unsubscribe = $ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
    $scope.$on('$destroy', unsubscribe);

    this.editMode = true;
    $('[data-toggle="tooltip"]').tooltip();
  }

  onTabChange(tab) {
    this.setTab(tab);
  }

  onSave() {
    this.save({
      sprintId: this.sprint.sprintId,
      projectId: this.sprint.projectId,
      prevId: this.sprint.prevId,
      teamId: this.sprint.teamId,
      name: this.sprint.name,
      startDate: this.sprint.startDate,
      endDate: this.sprint.endDate,
      capacity: this.sprint.capacity,
      users: this.sprint.users,
      costOfEstimationUnit: +this.sprint.costOfEstimationUnit,
      costOfEstUnitInherit: this.sprint.costOfEstUnitInherit,
      status: this.sprint.status,
      isDeleted: this.sprint.isDeleted
    });
    this.close();
  }
  onNext() {
    this.load({ sprintId: this.sprint.nextId });
  }
  onPrev() {
    this.load({ sprintId: this.sprint.prevId });
  }
  newItem() {
    this.close();
    this.create({ projectId: this.sprint.projectId, sprintId: this.sprint.sprintId });
  }

  onSelectedWeek(week) {
      this.setWeek(week);
  }

  onUserDayChange(user, day) {
    this.setUserDay({ user, day });
  }

  onNameChanged() {
    this.setName(this.sprint.name);
  }

  onStartDateChanged() {
    this.setStartDate(moment(this.sprint.startDate).toISOString());
  }

  onEndDateChanged() {
    this.setEndDate(moment(this.sprint.endDate).toISOString());
  }

  onCapacityChanged() {
    this.setCapacity(Number(this.sprint.capacity));
  }

  onHourCapacityChanged() {
    this.setHourCapacity(Number(this.sprint.hourCapacity));
  }

  onInheritChanged() {
    this.inheritCostChange({ costOfEstUnitInherit: this.sprint.costOfEstUnitInherit });
  }

  onCostChanged() {
    this.setCostOfEstimation(this.costOfEstimationModel);
  }

  onWorkingDurationChanged(user) {
    this.setWorkingDuration({ user })
  }

  noChanges() {
    if(this.origValues) {
      for(const key in this.origValues) {
        if(key !== 'sprintValue' && this.origValues.hasOwnProperty(key) && difference(this[key], this.origValues[key]) !== 0) {
          return false;
        }
      }
      return difference(this.sprint, this.origValues.sprintValue) === 0;
    }
    return true;
  }

  onCompleteConfirm() {
    let _this = this;
    ttb.Notifications.ShowConfirmationPopup(this.$translate.instant('Sprint_Confirm_Title'), this.$translate.instant('Complete_Confirm_Body'), function(){
      _this.onComplete(_this)
    });
  }
  onComplete(_this) {
    _this.complete({
      sprintId: _this.sprint.sprintId
    });
    _this.close();
  }

  onRemove() {
    this.remove();
  }

  onActivateConfirm()
  {
    let _this = this;
    ttb.Notifications.ShowConfirmationPopup(this.$translate.instant('Sprint_Confirm_Title'), this.$translate.instant('ActivateSprint_Confirm_Body'), function(){
      _this.onActivate(_this)
    });
  }

  onActivate(_this) {
    _this.activate({
          sprintId: _this.sprint.sprintId
      });
      _this.close();
  }

  isCompleted() {
    return this.sprint && this.sprint.status === ttb.constants.sprintStatuses.completed;
  }

  isUpcoming() {
    return this.sprint && this.sprint.status === ttb.constants.sprintStatuses.upcoming;
  }

  isActive() {
    return this.sprint && this.sprint.status === ttb.constants.sprintStatuses.active;
  }
}

export default SprintEditorPopup;



// WEBPACK FOOTER //
// ./components/popups/sprint/editor/sprint-editor-popup.controller.js